import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { prependNotification } from '../features/notificationsSlice';

const WS_URL = process.env.REACT_APP_WS_URL || 'wss://api.doramahype.ru/api/v1/ws';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

export function useOnlineSocket() {
  // Следим за самим токеном — если он обновился (после refresh), пересоздаём соединение
  const accessToken = useSelector((state) => state.auth.accessToken);
  const dispatch = useDispatch();
  const aliveRef = useRef(true);
  const timerRef = useRef(null);
  const wsRef = useRef(null);

  useEffect(() => {
    aliveRef.current = true;

    function connect() {
      if (wsRef.current) {
        wsRef.current.onclose = null;
        wsRef.current.close();
        wsRef.current = null;
      }

      let url;
      if (accessToken) {
        url = `${WS_URL}?token=${encodeURIComponent(accessToken)}`;
      } else {
        const sid = getCookie('guest_session_id');
        url = sid ? `${WS_URL}?sid=${encodeURIComponent(sid)}` : WS_URL;
      }

      const ws = new WebSocket(url);
      wsRef.current = ws;

      ws.onmessage = (event) => {
        try {
          const msg = JSON.parse(event.data);
          if (msg.type === 'notification') {
            dispatch(prependNotification(msg.payload));
          }
        } catch {
          // игнорируем не-JSON сообщения (например ping-фреймы)
        }
      };

      ws.onclose = () => {
        wsRef.current = null;
        if (aliveRef.current) {
          timerRef.current = setTimeout(connect, 5000);
        }
      };

      ws.onerror = () => {
        ws.close();
      };
    }

    connect();

    return () => {
      aliveRef.current = false;
      clearTimeout(timerRef.current);
      if (wsRef.current) {
        wsRef.current.onclose = null;
        wsRef.current.close();
        wsRef.current = null;
      }
    };
  // Пересоздаём соединение при смене токена (логин, логаут, refresh)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);
}
